"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferModule = void 0;
const statements_1 = require("./statements");
const builtins_1 = require("./builtins");
function inferModule(module) {
    return module.statements.reduce(statements_1.inferStatement, builtins_1.builtins);
}
exports.inferModule = inferModule;
//# sourceMappingURL=module.js.map